/**
 * API_PATHS
 *
 * @description - An object containing all the API paths.
 */
export const API_PATHS = {
  ADMIN: {
    BASE: 'admin',
    SIGN_IN: 'sign-in',
    SIGN_OUT: 'sign-out',
    AUTHENTICATED: 'authenticated',
    FORCE_CHANGE_PASSWORD: 'force-change-password',
    // Subscription Management
    SUBSCRIPTIONS: 'subscriptions',
    SUBSCRIPTION_PLANS: 'subscription-plans',
    CREATE_PLAN: 'subscription-plans/create',
    UPDATE_PLAN: 'subscription-plans/:id',
    DELETE_PLAN: 'subscription-plans/:id',
    CANCEL_USER_SUBSCRIPTION: 'subscriptions/:id/cancel',
    EXTEND_TRIAL: 'subscriptions/:id/extend-trial',
    REFUND_SUBSCRIPTION: 'subscriptions/:id/refund',
    CHANGE_USER_PLAN: 'subscriptions/:id/change-plan',
    INVOICES: 'invoices',
    // Audit Logs
    AUDIT_LOGS: 'audit-logs',
    AUDIT_LOGS_EXPORT: 'audit-logs/export',
    AUDIT_LOGS_STATS: 'audit-logs/stats',
    // System health (admin-only diagnostic)
    HEALTH: 'health',
    PLATFORM_STATS: 'platform-stats',
    INQUIRIES: 'inquiries',
    INQUIRY_BY_ID: 'inquiries/:id',
    INQUIRY_MARK_READ: 'inquiries/:id/read',
    INQUIRY_DELETE: 'inquiries/:id',
    // Cross-tenant browse endpoints
    PLATFORM_CUSTOMERS: 'platform/customers',
    PLATFORM_SERVICE_ITEMS: 'platform/service-items',
    PLATFORM_BOOKINGS: 'platform/bookings',
    PLATFORM_REVIEWS: 'platform/reviews',
    PLATFORM_NOTIFICATIONS: 'platform/notifications',
    PLATFORM_SERVICE_FORMS: 'platform/service-forms',
    PLATFORM_PUSH_TOKENS: 'platform/push-tokens',
    PLATFORM_STAFF: 'platform/staff',
    PLATFORM_SERVICES: 'platform/services',
    PLATFORM_OVERVIEW: 'platform/overview',
    // Company Management
    COMPANIES: 'companies',
    COMPANY_BY_ID: 'companies/:id',
    CREATE_COMPANY: 'companies/create',
    UPDATE_COMPANY: 'companies/:id',
    DELETE_COMPANY: 'companies/:id',
    // User Management
    USERS: 'users',
    USER_BY_ID: 'users/:id',
    DELETE_USER: 'users/:id',
    UPDATE_USER: 'users/:id',
    VERIFY_USER: 'users/:id/verify',
  },
  USERS: {
    BASE: 'users',
    SIGN_UP: 'sign-up',
    LOGIN: 'login',
    VERIFY: 'verify',
    RESEND_VERIFICATION_CODE: 'resend-verification-code',
    RESEND_VERIFICATION_CODE_EMAIL: 'resend-verification-code-email',
    FORGOT_PASSWORD: 'forgot-password',
    RESET_PASSWORD_REQUEST: 'reset-password-request',
    RESET_PASSWORD: 'reset-password',
    REFRESH_TOKEN: 'refresh-token',
    AUTHENTICATED: 'authenticated',
    LOGOUT: 'logout',
    GOOGLE: 'google',
    GOOGLE_CALLBACK: 'google/callback',
    MOBILE_GOOGLE_SIGN_IN: 'mobile/google-sign-in',
    MOBILE_FACEBOOK_SIGN_IN: 'mobile/facebook-sign-in',
    FACEBOOK: 'facebook',
    FACEBOOK_CALLBACK: 'facebook/callback',
    CHANGE_FULL_NAME: 'change-full-name',
    CHANGE_EMAIL: 'change-email',
    CHANGE_CONTACT_INFO: 'change-contact-info',
    UNLINK_GOOGLE: 'unlink-google',
    UNLINK_FACEBOOK: 'unlink-facebook',
  },
  ACTIVITY_FEED: {
    BASE: 'activity-feed',
    COMPANY: 'company',
    CUSTOMER: 'customer',
    COUNTS: 'counts',
    STAR: 'star',
    ARCHIVE: 'archive',
    ASSIGN: 'assign',
    SEND_REQUEST_TO_LINK_CUSTOMER_ON_SERVICE_ITEM: 'send-request-to-link-customer-on-service-item',
    SEND_REQUEST_TO_BOOK_SERVICE: 'send-request-to-book-service',
  },
  EXPLORE: {
    BASE: 'explore',
    LISTINGS: 'listings',
    CATEGORIES: 'categories',
    FAVORITES: 'favorites',
  },
  ANALYTIC: {
    BASE: 'analytic',
    SERVICE_ITEM_STATUS: 'service-item-statuses',
    TAGS_FREQUENCY: 'tags-frequency',
    TOTAL_REVENUE: 'total-revenue',
    AVERAGE_DURATION: 'average-duration',
    MOST_USED_STATUS: 'most-used-status',
    OLDEST_ITEM: 'oldest-item',
    PRICE_DISTRIBUTION: 'price-distribution',
    // Performance dashboard endpoints (new design)
    OVERVIEW_KPIS: 'overview-kpis',
    REQUESTS_OVER_TIME: 'requests-over-time',
    SERVICE_BREAKDOWN: 'service-breakdown',
    FUNNEL: 'funnel',
    FUNNEL_DETAIL: 'funnel-detail',
    TOP_SERVICES: 'top-services',
    TOP_STAFF: 'top-staff',
    HEATMAP: 'heatmap',
    CUSTOMER_STATS: 'customer-stats',
    TEAM_STATS: 'team-stats',
    EXPERIENCE_STATS: 'experience-stats',
  },
  APPOINTMENTS: {
    BASE: 'appointment',
  },
  LANDING: {
    BASE: 'landing',
    POTENTIAL_USER_SEND_MESSAGE: 'potential-user-send-message',
    BLOG_BY_INDEX: 'blog-by-index',
    MESSAGES: 'messages',
  },
  HELP: {
    BASE: 'help',
    ALL: "all",
    TOPIC: 'topic',
    OVERVIEW: 'overview',
    ABOUT: 'about',
  },
  BUG_REPORTS: {
    BASE: 'bug-reports',
    MINE: 'mine',
    ATTACHMENT: ':id/attachments/:index',
    BY_ID: ':id',
  },
  BOOKING: {
    BASE: 'booking',
    ALL: 'all',
    CUSTOMER: 'customer',
    EDIT: 'edit',
    REQUEST: 'request',
    RANGE: 'range',
    RESCHEDULE: 'reschedule',
  },
  Service_FORMS: {
    BASE: 'service-forms',
    COMPANY: 'company',
  },
  CHAT: {
    BASE: 'chat',
    GET_CONVERSATIONS: 'get-conversations',
    GET_MESSAGES: 'get-messages',
    GET_MESSAGES_BY_SCHEDULE: 'get-messages-by-schedule',
    GET_STAFF_CONVERSATIONS: 'get-staff-conversations',
    GET_STAFF_MESSAGES: 'get-staff-messages',
    CREATE_CONVERSATION: 'create-conversation',
    CREATE_MESSAGE: 'create-message',
    MARK_AS_READ: 'mark-as-read',
    GET_UNREAD_COUNT: 'get-unread-count',
  },
  COMPANY: {
    BASE: 'company',
    CREATE_COMPANY_FOR_USER: 'create-company-for-user',
    APPLY_TEMPLATE: ':id/apply-template',
    SET_WORKING_HOURS: ':id/working-hours',
    HOLIDAYS: ':id/holidays',
    DELETE_HOLIDAY: ':id/holidays/:holidayId',
  },
  CUSTOMER: {
    BASE: 'customer',
    SEARCH_BY_NAME: 'search-by-name',
    CREATE_CUSTOMER_FOR_USER: 'create-customer-for-user',
  },
  SERVICE_ITEM: {
    BASE: 'service-item',
    COMPANY: 'company',
    CUSTOMER: 'customer',
    ITEM: 'item',
    CONNECT_CUSTOMER_TO_TRACK_CODE: 'connect-customer-to-track-code',
    STOP_TRACKING: 'stop-tracking',
    CONFIRM: 'confirm',
    CANCEL_BY_CUSTOMER: 'cancel-by-customer',
    DASHBOARD_STATS: 'dashboard-stats',
    COUNT_BY_STATUS: 'count-by-status',
    STAGES: 'stages',
    AUTO_ADVANCE: 'auto-advance',
    COMPLETE_STAGE: 'complete',
    SKIP_STAGE: 'skip',
    EXTEND_STAGE: 'extend',
    REWIND_STAGE: 'rewind',
  },
  TRACKING_SERVICE_ITEM: {
    BASE: 'tracking-service-item',
    TRACK: 'track',
    GENERATE_CODE_FOR: 'generate-code-for',
    /** Public (un-authed) stages-by-tracking-code endpoint. */
    STAGES: 'stages',
  },
  LOCATIONS: {
    BASE: 'locations',
    UPDATE_ADDRESS: 'update-address',
    NEARBY: 'nearby',
  },
  NOTIFICATIONS: {
    BASE: 'notifications',
    SAVE_TOKEN: 'save-token',
  },
  SERVICES: {
    BASE: 'services',
    SERVICE: 'service',
    GROUPS: 'groups',
    ALL: 'all',
    ALL_PUBLIC: 'all_public',
    ADD_SERVICE: 'add-service',
    PUBLIC: 'public',
    STAGES: 'stages',
    REORDER: 'reorder',
  },
  GATEWAY: {
    ACTIVITY_FEED_CUSTOMER: 'activity-feed-customer',
    ACTIVITY_FEED_COMPANY: 'activity-feed-company',
    SERVICE_ITEM: 'service-item',
    CHAT_MESSAGE_CUSTOMER: 'chat-message-customer',
    CHAT_MESSAGE_COMPANY: 'chat-message-company',
    CHAT_MESSAGE_STAFF: 'chat-message-staff',
  },
  LEADS: {
    BASE: 'lead',
    ALL: 'all',
    PAGE: 'page',
    STATS: 'stats',
  },
  SUBSCRIPTION: {
    BASE: 'subscription',
    CONFIRM_SESSION: 'confirm-session',
    CREATE_SESSION: 'create-session',
    GET_SUBSCRIPTION: 'get-subscription',
    CANCEL: 'cancel',
    REACTIVATE: 'reactivate',
    UPGRADE: 'upgrade',
    CUSTOMER_PORTAL: 'customer-portal',
    INVOICE_HISTORY: 'invoice-history',
    WEBHOOK: 'webhook',
  },
  STAFF: {
    BASE: 'staff',
    AUTH: 'auth',
    LOGIN: 'auth/login',
    SERVICES: 'services',
  },
};
